import { render, staticRenderFns } from "./UserVip.vue?vue&type=template&id=689283f4&scoped=true&"
import script from "./UserVip.vue?vue&type=script&lang=js&"
export * from "./UserVip.vue?vue&type=script&lang=js&"
import style0 from "./UserVip.vue?vue&type=style&index=0&id=689283f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689283f4",
  null
  
)

export default component.exports